<script lang="ts" setup>
	import DetailOverviewTable from '@/components/DetailOverviewTable.vue';
	import {useDetails} from '@/store/details.store';
	import {useRegionStore} from '@/store/region.store';
	import {computed, onMounted} from 'vue';
	import OverviewWrapper from '@/views/OverviewWrapper.vue';

	const detailStore = useDetails();

	const products = computed(() => detailStore.products ?? []);

	const productHeaders = computed(() => detailStore.tableHeaders?.static ?? []);

	const detailHeaders = computed(() => detailStore.tableHeaders?.dynamic ?? {});

	const numberOfResults = computed(() => detailStore.numberOfResults);

	const getResult = async () => await detailStore.getDetailResult();

	onMounted(async () => {
		await useRegionStore().loadRegions();
		await getResult();
	});
</script>

<template>
	<OverviewWrapper :number-of-results="numberOfResults" @update-overview="getResult">
		<DetailOverviewTable :detail-headers="detailHeaders"
		                     :number-of-results="numberOfResults"
		                     :product-headers="productHeaders"
		                     :products="products"
		                     @on-update-data="getResult" />
	</OverviewWrapper>
</template>
